import { CurrentOutages } from '../outages/CurrentOutages';
import { CurrentEnergy } from '../energy/CurrentEnergy';

export function CurrentTab() {
  return (
    <>
      <section className="App-section">
        <CurrentOutages />
      </section>

      <section className="App-section">
        <CurrentEnergy />
      </section>
    </>
  );
}
